import { useTheme } from '@terminal/react-query-hooks/themes/useThemeOverview';
import { parseThemeIdFromChartTag } from '@terminal/views/turbo-chart/utils/chart-theme-asset/chartThemeAsset';

import { ThemeSearchLogo } from './ThemeSearchLogo';

export interface ThemeChartLogoProps {
  tag: string;
  name: string;
  size?: 16 | 32;
}

export const ThemeChartLogo = ({ tag, name, size }: ThemeChartLogoProps) => {
  const { data } = useTheme({ themeId: parseThemeIdFromChartTag(tag) });

  return (
    <ThemeSearchLogo
      name={name}
      logoUrl={data?.logo_url}
      themeType={data?.type}
      size={size}
    />
  );
};
